// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol___5SqP","author":"Table_author__2R5kA","authorImage":"Table_authorImage__1JK_K","unreadRow":"Table_unreadRow__DqlmJ"};